/**
 * ネットワーク接続状態監視フック
 * オンライン/オフラインの切替を検知します
 */

import { useEffect, useState } from 'react';

/**
 * ネットワーク接続状態を監視するフック
 * 初期値はtrue（オンライン扱い）とし、isConnectedが明示的にfalseの場合のみオフラインとする。
 * 起動直後などisConnectedがnull（未確定）の場合はオンライン扱いのままにして、
 * バナーが一瞬誤表示されるのを防ぐ。
 * @returns {{ isOnline: boolean }} 接続状態
 */
const useNetworkStatus = () => {
  /** オンライン状態 */
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    /**
     * オンライン状態へ更新する
     * @returns {void}
     */
    const handleOnline = () => setIsOnline(true);

    /**
     * オフライン状態へ更新する
     * @returns {void}
     */
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
};

export default useNetworkStatus;
